import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchSampleCollection = async (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  const data = await axiosInstance.get(EndPoints.SAMPLECOLLECTION.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
    },
  });
  return data;
};

export const fetchSampleCollectionInResultEntry = async (
  page_no,
  appointment_id
) => {
  const data = await axiosInstance.get(EndPoints.SAMPLECOLLECTION.LIST, {
    params: {
      page_no,
      appointment_id, // Only passing appointment_id
    },
  });
  return data;
};

export const fetchParticularAppointment = async (payload) => {
  const { appointment_id } = payload;
  return await axiosInstance.get(EndPoints.SAMPLECOLLECTION.LIST, {
    params: {
      appointment_id: Number(appointment_id),
      zone_id,
    },
  });
};
export const fetchSampleInformation = (payload) => {
  return axiosInstance.get(
    EndPoints.SAMPLECOLLECTION.SAMPLEINFORMATION +
      `?registartion_id=${parseInt(payload)}`
  );
};
export const createSampleCollectRejectionReason = (payload) => {
  return axiosInstance.post(EndPoints.SAMPLECOLLECTION.CREATE, payload);
};

export const createSamplePrintMachine = (payload) => {
  return axiosInstance.post(EndPoints.SAMPLECOLLECTION.MACHINE_CREATE, payload);
};

export const createFranchise = (payload) => {
  return axiosInstance.post(EndPoints.Franchise.CREATE, payload);
};

export const updateFranchise = (payload) => {
  return axiosInstance.put(EndPoints.Franchise.UPDATE, payload);
};

export const deleteFranchise = (payload) => {
  const url = EndPoints.Franchise.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadFranchiseCSV = () => {
  return axiosInstance.put(EndPoints.Franchise.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};
